/* eslint-disable @typescript-eslint/camelcase */
import { FcsFlag } from "../unleash";

/**
 * Incoming & Outgoing – permission flags per path.
 * Used by router meta.permission and list view to gate access. Namespace: featureIncomingOutgoing.
 */
const FcsPermissionIncomingOutgoing = {
  permission_incoming_outgoing_enable: new FcsFlag.Flag(false),
  permission_incoming_outgoing_cargo_detail_view: new FcsFlag.Flag(false),
  permission_incoming_outgoing_cargo_detail_edit: new FcsFlag.Flag(false),
  permission_incoming_outgoing_cargo_detail_legacy_edit: new FcsFlag.Flag(false), // default false di config false juga
  permission_incoming_outgoing_bagging_detail_view: new FcsFlag.Flag(false),
  permission_incoming_outgoing_bagging_detail_edit: new FcsFlag.Flag(false),
  permission_incoming_outgoing_sti_dest_detail_view: new FcsFlag.Flag(false)
};

export const FlagsPermissionIncomingOutgoing = {
  ...FcsPermissionIncomingOutgoing
};

export function initFlagsPermissionIncomingOutgoing() {
  FcsFlag.register("featureIncomingOutgoing", FcsPermissionIncomingOutgoing);
}
